import styled from 'styled-components';

export const NewHireExceptionHistoricContainer = styled.div`
  display: flex;
  margin: 2%;
  flex-direction: column;
`;

export const NewHireExceptionHistoricHeader = styled.div`
  display: flex;
  width: 100%;
`;

export const NewHireExceptionHistoricTitle = styled.h3`
  display: flex;
  margin: 2%;
  margin-left: -2%;
  color: #222247;
`;
